import { FC, PropsWithChildren } from 'react'
import styles from './index.module.less'

const GlobalLoading: FC<
  PropsWithChildren<{
    loading: boolean
  }>
> = (props) => {
  return (
    <>
      {props.children}
      {props.loading ? (
        <div className={styles.loadingWrap}>
          <div className={styles.loading} />
        </div>
      ) : null}
    </>
  )
}

export default GlobalLoading
